import { render, staticRenderFns } from "./towPage.vue?vue&type=template&id=d71413b2&scoped=true"
import script from "./towPage.vue?vue&type=script&lang=js"
export * from "./towPage.vue?vue&type=script&lang=js"
import style0 from "./towPage.vue?vue&type=style&index=0&id=d71413b2&prod&lang=scss&scoped=true"
import style1 from "./towPage.vue?vue&type=style&index=1&id=d71413b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d71413b2",
  null
  
)

export default component.exports